import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as HelpIcon } from 'assets/images/HelpIcon/helpIcon.svg';
import { Button } from 'components';
import { getDataCatalogoBeneficiados } from 'actions/identificacionSO.action';
import * as errorFieldsMsgs from 'constants/formFieldsMessages';
import { Form, Select, Row, Col, Input } from 'antd';
import * as resetFieldsBSO from './utilsIdentificacionSO/resetFiltersBuscadorSO';
import { catFilter } from './utilsIdentificacionSO/payloadsIdSO';

const ambitos = [
  { idAmbito: 1, ambitoDesc: 'Federal' },
  { idAmbito: 2, ambitoDesc: 'Local' }
];

export const BuscadorSO = (props) => {
  const { form, onClear, onSearchDataSources, resetDataBeneficiados, resetDataCandidatosAp } =
    props;
  const [procesosElectorales, setProcesosElectorales] = useState([]);
  const [procesosEspecificos, setProcesosEspecificos] = useState([]);
  const [tipoAsociaciones, setTipoAsociaciones] = useState([]);
  const [sujetosObligadosAprobados, setSujetosObligadosAprobados] = useState([]);

  const { setFieldsValue } = form;

  const overlayStyleSO = {
    width: '10rem',
    maxWidth: '12rem'
  };
  const overlayInnerStyleSO = {
    backgroundColor: '#333',
    borderRadius: '10px',
    padding: '12px'
  };

  const getCatalogosBeneficiados = async (payload) => {
    try {
      const { success, data: response } = await getDataCatalogoBeneficiados(payload);
      if (success && response.procesosElectorales) {
        setProcesosElectorales(response.procesosElectorales);
        setProcesosEspecificos(response.procesosEspecificos);
        setTipoAsociaciones(response.tipoAsociaciones);
      }
      if (success && response.sujetosObligadosAp)
        setSujetosObligadosAprobados(response.sujetosObligadosAp);
    } catch (error) {
      console.log('Error al ontener el catálogo de los filtros', error);
    }
  };

  useEffect(() => {
    getCatalogosBeneficiados();
  }, []);

  /* ************************* onChange's de los selectores ************************* */

  const onChangeSujetoObligado = () => resetDataBeneficiados();

  const onChangeCandidatosAprobados = () => resetDataCandidatosAp();

  const onChangeTipoAsociacion = () => {
    const values = form.getFieldsValue();
    getCatalogosBeneficiados(catFilter(values));
    resetFieldsBSO.resetSujetosObligadosFields(setFieldsValue);
  };

  const onChangeProcesoEspecifico = () => {
    resetFieldsBSO.resetTipoAsociacion(setFieldsValue);
  };

  const onChangeAmbito = () => {
    resetFieldsBSO.resetProcesoEspecifico(setFieldsValue);
  };

  const onChangeProcesoElectoral = () => {
    resetFieldsBSO.resetAmbitoProcesoEspecifico(setFieldsValue);
  };

  /* ************************* Manejadores de los botones Buscar y limpiar ************************* */

  const handleClear = () => onClear();

  const handleBuscarBeneficiados = () => {
    onSearchDataSources();
  };

  /* ************************* Renderizado de los Filtros ************************* */

  return (
    <Form id="formBuscadorSO" layout="vertical" form={form}>
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
        <Col span={6} xs={6}>
          <Form.Item
            name="idProcesoElectoral"
            label="Proceso Electoral:"
            rules={[{ required: true, message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
            <Select
              placeholder="Selecciona"
              options={procesosElectorales.map((p) => ({
                value: p.idProcesoElectoral,
                label: p.descripcion
              }))}
              onChange={onChangeProcesoElectoral}
            />
          </Form.Item>
        </Col>
        <Col span={6} xs={6}>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const idProcesoElectoral = form.getFieldValue('idProcesoElectoral');
              return (
                <Form.Item
                  name="ambito"
                  label="Ámbito:"
                  rules={[{ required: true, message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    placeholder="Selecciona"
                    disabled={!idProcesoElectoral}
                    options={ambitos.map((a) => ({
                      value: a.idAmbito,
                      label: a.ambitoDesc
                    }))}
                    onChange={onChangeAmbito}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={6} xs={6}>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const { idProcesoElectoral, ambito } = form.getFieldsValue();
              const disableIdProcesoEspecifico = !(idProcesoElectoral && ambito);
              return (
                <Form.Item
                  name="idProcesoEspecifico"
                  label="Proceso:"
                  rules={[{ required: true, message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    placeholder="Selecciona"
                    disabled={disableIdProcesoEspecifico}
                    options={procesosEspecificos.map((p) => ({
                      value: p.idProcesoEspecifico,
                      label: p.nombreProcesoEspecifico
                    }))}
                    onChange={onChangeProcesoEspecifico}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={6} xs={6}>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const idProceso = form.getFieldValue('idProcesoEspecifico');
              let tipoAsociacionC = [];
              if (idProceso)
                tipoAsociacionC = tipoAsociaciones.find(
                  (tipoAsoc) => tipoAsoc.idProceso === idProceso
                ).tipoAsociacionesList;
              return (
                <Form.Item
                  name="idTipoAsociacion"
                  label="Tipo de asociación:"
                  rules={[{ required: true, message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    placeholder="Selecciona"
                    disabled={!idProceso}
                    options={tipoAsociacionC?.map((tipo) => ({
                      value: tipo.idTipoAsociacion,
                      label: tipo.descripcion
                    }))}
                    onChange={onChangeTipoAsociacion}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={6} xs={6}>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const idTipoAsociacion = form.getFieldValue('idTipoAsociacion');
              return (
                <Form.Item
                  name="sujetoObligadoIdentificar"
                  label="Sujeto Obligado:"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED
                    }
                  ]}
                  tooltip={{
                    title: 'Sujetos Obligados de beneficiados capturados manualmente en SIMAC.',
                    icon: <HelpIcon />,
                    placement: 'bottomLeft',
                    arrow: false,
                    overlayStyle: overlayStyleSO,
                    overlayInnerStyle: overlayInnerStyleSO
                  }}>
                  <Input
                    placeholder="Escribe"
                    disabled={!idTipoAsociacion}
                    onChange={onChangeSujetoObligado}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={6} xs={6}>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const idTipoAsociacion = form.getFieldValue('idTipoAsociacion');
              return (
                <Form.Item
                  name="idSujetoObligadoAprobados"
                  label="Sujeto Obligado Aprobado:"
                  rules={[{ required: true, message: errorFieldsMsgs.ERR_SELECT_FIELD_REQUIRED }]}
                  tooltip={{
                    title: 'Sujetos Obligados registrados en SNR y/o SIRCF.',
                    icon: <HelpIcon />,
                    placement: 'bottomLeft',
                    arrow: false,
                    overlayStyle: { ...overlayStyleSO, width: '8rem' },
                    overlayInnerStyle: overlayInnerStyleSO
                  }}>
                  <Select
                    disabled={!idTipoAsociacion}
                    placeholder="Selecciona"
                    options={sujetosObligadosAprobados?.map((tipo) => ({
                      value: tipo.idSujetoObligado,
                      label: tipo.sujetoObligado
                    }))}
                    onChange={onChangeCandidatosAprobados}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <Row className="buscador-so-botones">
        <Col span={4}>
          <Row style={{ justifyContent: 'space-between' }}>
            <Button text="Limpiar" onClick={handleClear} />
            <Button text="Buscar" type="primary" onClick={handleBuscarBeneficiados} />
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

BuscadorSO.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    resetFields: PropTypes.func
  }).isRequired,
  onClear: PropTypes.func.isRequired,
  onSearchDataSources: PropTypes.func.isRequired,
  resetDataCandidatosAp: PropTypes.func.isRequired,
  resetDataBeneficiados: PropTypes.func.isRequired
};
